import styled from 'styled-components';

export const CircularProgressWrapper = styled.div`
  background-color: #fafafa !important;
  padding: 10px !important;
  display: flex !important;
  justify-content: center !important;
`;
